import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { dispatchModuleAction } from "2g-utils-redux";
import { actions as formActions } from "2g-form";

import { FORM_REZERVACE_VYTVORENI_MODULE_KEY } from "../RezervaceVytvoreniForm";

export default function useRezervaceVytvoreniFormLogoutDestroy() {
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      dispatchModuleAction(
        dispatch,
        FORM_REZERVACE_VYTVORENI_MODULE_KEY,
        formActions.destroy()
      );
    },
    []
  );
}
